// extracted by mini-css-extract-plugin
export default {"shell":"AppShell_shell__udZ-C","main":"AppShell_main__vznLz","workspace":"AppShell_workspace__hTLs-","resizer":"AppShell_resizer__sbJlU","toast":"AppShell_toast__zSA8b"};